/**
 * Factory for a vuex moodule
 * @param {?Vuex.StoreOptions<S>} param0 - The module definition
 * @param {?S} param0.state - The raw state of the module
 * @param {?Vuex.GetterTree<S,S>} param0.getters - The getters of the module
 * @param {?Vuex.MutationTree<S>} param0.mutations - The mutations of the module
 * @param {?Vuex.ActionTree<S, S>} param0.actions - The actions of the module
 * @return {Vuex.StoreOptions<S>} the fully initialized module
 */
const makeModule = ({
    state = {},
    getters = {},
    mutations = {},
    actions = {},
} = {}) => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
});

export {
    makeModule,
}